import React, { memo } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const SignatureCheckDialog = memo(
  ({ open, onClose, applicantType = "Borrower Only" }) => {
    const signatureRules = {
      "Borrower Only": ["Borrower signature in Loan Application & Agreement"],
      "Borrower + Co-Borrower": [
        "Both signatures in Loan Application & Agreement",
      ],
      "Borrower + Guarantor": [
        "Both signatures in Loan Application & Agreement",
      ],
      "Borrower + Guarantor + Co-Borrower": [
        "All three signatures in Loan Application & Agreement",
      ],
    };

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Signature Check (AMU Only)</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <Typography
              variant="body2"
              sx={{ mb: 2, fontWeight: 600, color: "#374151" }}
            >
              Applicant Type: {applicantType}
            </Typography>
            <Box
              sx={{
                backgroundColor: "#f0fdf4",
                p: 2,
                borderRadius: 1,
                border: "1px solid #86efac",
              }}
            >
              {signatureRules[applicantType]?.map((rule, idx) => (
                <Typography
                  key={idx}
                  variant="body2"
                  sx={{ color: "#059669", mb: 1 }}
                >
                  • {rule}
                </Typography>
              ))}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

SignatureCheckDialog.displayName = "SignatureCheckDialog";

export default SignatureCheckDialog;
